/* eslint-disable @typescript-eslint/no-explicit-any */
import classNames from "classnames";
import { Swiper, SwiperSlide } from "swiper/react";

import React from "react";
import { useDispatch, useSelector } from "react-redux";

import {
    memoizedGetStepTags,
    setSteptag,
} from "@components/OrderTaking/Store/feature/DataworkflowSlice";

import { Tag } from "./Tag";
import "./tags.css";

import "swiper/swiper.min.css";

export function WorkFlowTagsSwiper(): JSX.Element | null {
    const dispatch = useDispatch();

    const currentTags = useSelector((state: any) => memoizedGetStepTags(state));

    function handleActiveTagOnClickEvent(event: React.MouseEvent<HTMLElement>) {
        const itemId = event.currentTarget.dataset.id;
        const newTags = currentTags.map((tag: any) => {
            if (tag.id === itemId) {
                return {
                    ...tag,
                    active: !tag.active,
                };
            }
            return { ...tag };
        });

        dispatch(setSteptag(newTags));
    }

    if (currentTags.length === 0) return null;
    return (
        <Swiper
            className="tags-swiper__clz py-1"
            spaceBetween={15}
            slidesPerView="auto"
            style={{
                maxWidth: "66rem",
                maxHeight: "4rem",
                margin: "1.5rem 1rem !important",
                padding: "0.5rem",
            }}
        >
            {currentTags.map((item: any) => {
                return (
                    <SwiperSlide
                        className={classNames({
                            "active-tags-swiper-width__clz":
                                item.active === true,
                            "tags-swiper-width__clz": item.active === false,
                        })}
                        key={item.id}
                        data-id={item.id}
                        onClick={handleActiveTagOnClickEvent}
                    >
                        <Tag tag={item} />
                    </SwiperSlide>
                );
            })}
        </Swiper>
    );
}
export const WorkFlowTagsSwiperMemoised = React.memo(WorkFlowTagsSwiper);
